import { render } from "./index.vue?vue&type=template&id=557c6f6e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/organisms/global-footer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "557c6f6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('557c6f6e', __exports__)) {
    api.reload('557c6f6e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=557c6f6e", () => {
    api.rerender('557c6f6e', render)
  })

}


export default __exports__